module.exports = __webpack_public_path__ + "oliverstravel-logo.png?c1fad4a3db6c84a6efecd7b0ccbf472b";